// ABOUTME: API slice for submitting frontend errors to the backend
// ABOUTME: Injects into the root slice following the standard domain slice pattern

import { rootSlice } from "../createRootSlice";

export const errorSlice = rootSlice.injectEndpoints({
    endpoints: (builder) => ({
        submitError: builder.mutation({
            query: (body) => ({
                url: '/error/submit',
                method: 'POST',
                body,
            }),
        }),
    }),
});

export const { useSubmitErrorMutation } = errorSlice;
